import { defineStore } from 'pinia'
import { computed } from 'vue'

export const usePlatformStore = defineStore('platformStore', () => {
  const isPhone = computed(() => {
    const platform = window?.device?.platform.toLowerCase()
    return platform === 'ios' || platform === 'android'
  })

  const platform = computed(() => {
    return window?.device?.platform.toLowerCase()
  })

  return {
    isPhone,
    platform
  }
})
